export default class LanguageSelector {
    constructor() {
        this.languageSelector = document.querySelectorAll('.languageSelector');
        this.bindEvents();
    }

    bindEvents() {
        for (let i = 0; i < this.languageSelector.length; i++) {
            this.languageSelector[i].addEventListener('click', () => this.languageSelector[i].classList.toggle('isOpen'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/languageSelector/languageSelector.js